export default function TenantBenefitsSection() {
  const benefits = [
    {
      icon: 'ri-home-smile-fill',
      title: 'Tenants Can Stay',
      description: 'Your tenants don\'t need to move out. We honor existing lease agreements and work with tenants to ensure a smooth transition. This eliminates the stress and cost of vacancy.'
    },
    {
      icon: 'ri-calendar-check-fill',
      title: 'No Showings Required',
      description: 'When you sell tenant occupied property to us, there are no endless showings disrupting your tenants. We make our offer based on property details and a single inspection.'
    },
    {
      icon: 'ri-file-shield-fill',
      title: 'Lease Transfers Handled',
      description: 'We manage all lease transfer paperwork and tenant notifications. Your tenants receive proper legal notice and their rights are fully protected throughout the process.'
    },
    {
      icon: 'ri-money-dollar-box-fill',
      title: 'Keep Collecting Rent',
      description: 'Continue collecting rent right up until closing. You don\'t lose rental income during the sale process like you would with traditional buyers who require vacant properties.'
    },
    {
      icon: 'ri-user-heart-fill',
      title: 'Tenant Privacy Protected',
      description: 'We respect tenant privacy and rights. Our process minimizes intrusion and maintains positive landlord-tenant relationships throughout the transaction.'
    },
    {
      icon: 'ri-shield-star-fill',
      title: 'Legal Compliance Guaranteed',
      description: 'All tenant notifications, lease transfers, and security deposit handling comply with Texas landlord-tenant laws. Our title company ensures everything is done correctly.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/af653881112716ac9c7d429ec6bcb151.jpg"
              alt="Sell With Tenants Benefits"
              className="w-full h-auto rounded-lg shadow-2xl object-cover"
            />
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Benefits of Selling With Tenants in Place
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Selling tenant occupied property offers unique advantages when you work with the right buyer. Unlike traditional sales that require vacant properties, we specialize in purchasing rental real estate with existing tenants.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              This approach saves you time, money, and stress while protecting your tenants\' rights and maintaining positive relationships. Here\'s how selling with tenants benefits everyone involved.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-teal-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-24 h-24 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-lightbulb-flash-fill text-teal-600 text-5xl"></i>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                The Smart Way to Sell Rental Property
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Traditional buyers often require properties to be vacant, forcing you to evict tenants or wait for leases to expire. This can take months and cost thousands in lost rent. When you sell tenant occupied property to T-Rex Real Estate, you avoid these problems entirely. We buy rental property as-is, with tenants in place, allowing you to close quickly while maintaining rental income until the day of closing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}